import { lazyLoad } from 'utils/loadable';

export const CareerPlanningFormPage = lazyLoad(
  () => import('./index'),
  module => module.CareerPlanningFormPage,
);
